module.exports = __webpack_public_path__ + "img/homepage-get-loan.367bbd77.png";